var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { AdminLayout } from "frontend/src/pages/layouts";
import { Box, Card, CardContent, CardMedia, Grid, IconButton, Menu, MenuItem, Typography, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { MoreVert } from "@material-ui/icons";
import { useChangePlaylistBusinessTypePublishStatus, usePlaylistBusinessTypes, } from "frontend/src/domain/playlist-business-type";
import { AddPlaylistBusinessType } from "./add-playlist-business-type";
var useStyles = makeStyles({
    cardMedia: {
        height: 282,
    },
    cardContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
});
var CardActions = function (_a) {
    var id = _a.id, isPublished = _a.isPublished;
    var _b = __read(React.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var mutate = useChangePlaylistBusinessTypePublishStatus().mutate;
    var changePublishStatus = function () {
        mutate({ id: id, publish: !isPublished });
        handleClose();
    };
    return (React.createElement(Box, null,
        React.createElement(IconButton, { size: "small", onClick: handleClick },
            React.createElement(MoreVert, null)),
        React.createElement(Menu, { anchorEl: anchorEl, keepMounted: true, open: open, onClose: handleClose },
            React.createElement(MenuItem, { onClick: changePublishStatus },
                React.createElement(Typography, null, isPublished ? "Снять с публикации" : "Опубликовать")))));
};
var Page = function () {
    var classes = useStyles();
    var data = usePlaylistBusinessTypes().data;
    return (React.createElement(Box, null,
        React.createElement(Box, { display: "flex", justifyContent: "space-between" },
            React.createElement(Typography, { variant: "h4" }, "\u041F\u043E \u0442\u0438\u043F\u0430\u043C \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0439"),
            React.createElement(AddPlaylistBusinessType, null)),
        React.createElement(Box, { mt: 5 },
            React.createElement(Grid, { container: true, spacing: 3 }, data === null || data === void 0 ? void 0 : data.items.map(function (item) { return (React.createElement(Grid, { item: true, xs: 3, key: item.id },
                React.createElement(Card, null,
                    React.createElement(CardMedia, { image: item.image, className: classes.cardMedia }),
                    React.createElement(CardContent, null,
                        React.createElement(Box, { className: classes.cardContent },
                            React.createElement(Box, null,
                                React.createElement(Typography, { display: "inline" }, item.title),
                                React.createElement(Box, { display: "inline-block", ml: 1 },
                                    React.createElement(Typography, { color: item.isPublished ? "initial" : "error" },
                                        "(",
                                        item.isPublished
                                            ? "опубликовано"
                                            : "не опубликовано",
                                        ")"))),
                            React.createElement(CardActions, { id: item.id, isPublished: item.isPublished })))))); })))));
};
export var PlaylistBusinessTypesPage = function () {
    return (React.createElement(AdminLayout, null,
        React.createElement(Page, null)));
};
